module.exports = __webpack_public_path__ + "img/patients-employer.9b0d5167.svg";